module.exports = __webpack_public_path__ + "img/6.795c459a.png";